import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import * as LucideIcons from "lucide-react";
import { ArrowRight } from "lucide-react";

export default function Settori() {
  const [sectors, setSectors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/sectors").then((r) => setSectors(r.data.items || [])).finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <div className="adr-overline mb-3">Esplora per settore</div>
      <h1 className="serif text-3xl sm:text-4xl font-semibold tracking-tight text-[#1A1A1A] mb-2">
        I tuoi reparti aziendali
      </h1>
      <p className="text-[#555555] mb-8 max-w-2xl">
        Scegli il reparto su cui vuoi lavorare: ti mostriamo ricette e soluzioni OSS pertinenti per le PMI manifatturiere italiane.
      </p>

      {loading ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {Array.from({ length: 6 }).map((_, i) => <div key={i} className="adr-skeleton h-32" />)}
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {sectors.map((s) => {
            const Icon = LucideIcons[s.icon] || LucideIcons.Folder;
            return (
              <div key={s.key} className="adr-card p-5" data-testid={`sector-${s.key}`}>
                <div className="flex items-start gap-3 mb-4">
                  <div className="w-11 h-11 rounded-md flex items-center justify-center" style={{ background: "rgba(15,61,107,0.08)" }}>
                    <Icon className="w-5 h-5" style={{ color: "#0F3D6B" }} strokeWidth={1.6} />
                  </div>
                  <div className="flex-1">
                    <h3 className="serif text-base font-semibold text-[#1A1A1A] leading-tight">{s.label}</h3>
                    <div className="text-xs text-[#555555] mt-1">{s.recipes_count} ricette · {s.oss_count} soluzioni OSS</div>
                  </div>
                </div>
                <div className="flex gap-2">
                  <Link to={`/catalogo?sector=${s.key}`} className="text-xs text-[#0F3D6B] hover:underline flex items-center gap-1" data-testid={`sector-${s.key}-recipes`}>
                    Ricette <ArrowRight className="w-3 h-3" />
                  </Link>
                  <Link to={`/soluzioni?sector=${s.key}`} className="text-xs text-[#0F3D6B] hover:underline flex items-center gap-1 ml-3" data-testid={`sector-${s.key}-oss`}>
                    Soluzioni OSS <ArrowRight className="w-3 h-3" />
                  </Link>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
